import { useRef, useCallback, MouseEvent } from 'react'

type UseLongPressOptions = {
  onLongPressStart?: () => void
  onLongPressEnd?: () => void
}

export function useLongPress({
  onLongPressStart,
  onLongPressEnd,
}: UseLongPressOptions) {
  const timerRef = useRef<NodeJS.Timeout | null>(null)

  const start = useCallback(() => {
    timerRef.current = setTimeout(() => {
      onLongPressStart?.()
    }, 400)
  }, [onLongPressStart])

  const clear = useCallback(() => {
    if (timerRef.current) {
      onLongPressEnd?.()
      clearTimeout(timerRef.current)
      timerRef.current = null
    }
  }, [onLongPressEnd])

  return {
    onMouseDown: start,
    onMouseUp: clear,
    onMouseLeave: clear,
    onTouchStart: start,
    onTouchEnd: clear,
    onContextMenu: (e: MouseEvent<HTMLDivElement>) => e.preventDefault(),
  }
}
